package dev.danko.roblox_craft_ai.uikit.icons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import org.jetbrains.compose.web.css.flexShrink
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.dom.Span

/**
 * Stroke icons in the style of Lucide (24×24 grid, 2px stroke, round caps), drawn with currentColor
 * so they follow the text color. Interface controls use these instead of emoji.
 */
enum class AppIcon(vararg val paths: String) {
    LOGO("M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z", "M12 12l8-4.5", "M12 12v9", "M12 12L4 7.5"),
    SPARKLES("M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z", "M19 3v4", "M21 5h-4"),
    CODE("M8 6l-6 6 6 6", "M16 6l6 6-6 6"),
    CUBE("M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z", "M12 12l8-4.5", "M12 12v9", "M12 12L4 7.5"),
    FIGURE(circle(12f, 5f, 2f), "M12 7v6l-3 7", "M12 13l3 7", "M8 10h8"),
    FOLDER("M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"),
    PAPERCLIP("M21 12.5l-8.5 8.5a5 5 0 01-7-7L14 5.5a3.3 3.3 0 014.7 4.7L10.2 18.7a1.7 1.7 0 01-2.4-2.4L15.5 8.6"),
    SLIDERS("M4 6h10", "M18 6h2", "M4 12h4", "M12 12h8", "M4 18h12", circle(16f, 6f, 2f), circle(10f, 12f, 2f), circle(18f, 18f, 2f)),
    SEARCH(circle(11f, 11f, 7f), "M20 20l-3.5-3.5"),
    CHEVRON_DOWN("M6 9l6 6 6-6"),
    SEND("M7 17L17 7", "M9 7h8v8"),
    DOWNLOAD("M12 4v11", "M7 10l5 5 5-5", "M5 20h14"),
    COPY("M9 9h10v10H9z", "M5 15V5h10"),
    MORE(circle(5f, 12f, 1f), circle(12f, 12f, 1f), circle(19f, 12f, 1f)),
    MORE_VERTICAL(circle(12f, 5f, 1f), circle(12f, 12f, 1f), circle(12f, 19f, 1f)),
    CLOSE("M6 6l12 12", "M18 6L6 18"),
    MENU("M4 7h16", "M4 12h16", "M4 17h16"),
    ZAP("M13 2L4 14h7l-1 8 9-12h-7l1-8z"),
    GLOBE(circle(12f, 12f, 9f), "M3 12h18", "M12 3a14 14 0 010 18", "M12 3a14 14 0 000 18"),
    MOON("M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z"),
    SUN(circle(12f, 12f, 4f), "M12 2v2", "M12 20v2", "M4.9 4.9l1.4 1.4", "M17.7 17.7l1.4 1.4", "M2 12h2", "M20 12h2", "M4.9 19.1l1.4-1.4", "M17.7 6.3l1.4-1.4"),
    SETTINGS(circle(12f, 12f, 3f), "M12 2v3", "M12 19v3", "M2 12h3", "M19 12h3", "M4.9 4.9l2.1 2.1", "M17 17l2.1 2.1", "M4.9 19.1L7 17", "M17 7l2.1-2.1"),
    SHIELD("M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z"),
    LOG_OUT("M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4", "M16 17l5-5-5-5", "M21 12H9"),
    USER(circle(12f, 8f, 4f), "M4 21a8 8 0 0116 0"),
    MESSAGE("M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"),
    HISTORY("M3 12a9 9 0 109-9 9.7 9.7 0 00-6.7 2.7L3 8", "M3 3v5h5", "M12 7v5l3 2"),
    ROTATE("M21 12a9 9 0 11-3-6.7L21 8", "M21 3v5h-5"),
    CAMERA("M4 8a2 2 0 012-2h2l2-2h4l2 2h2a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2z", circle(12f, 12.5f, 3.5f)),
    MAXIMIZE("M4 9V4h5", "M20 9V4h-5", "M4 15v5h5", "M20 15v5h-5"),
    CHECK("M5 12l5 5L20 7"),
    TRASH("M4 7h16", "M10 11v6", "M14 11v6", "M6 7l1 13h10l1-13", "M9 7V4h6v3"),
    PLUS("M12 5v14", "M5 12h14"),
    MINUS("M5 12h14"),
    LIGHTBULB("M9 18h6", "M10 22h4", "M12 2a7 7 0 00-4 12.7V17h8v-2.3A7 7 0 0012 2z"),
    CARD("M3 6h18v12H3z", "M3 10h18"),
    FLAG("M5 21V4", "M5 4h11l-2 4 2 4H5"),
    PENCIL("M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"),
    // Animation choices: combat modes, weapons and grips
    FIST("M7 11V8a2 2 0 0 1 4 0v2", "M11 10V7a2 2 0 0 1 4 0v3", "M15 10V8a2 2 0 0 1 4 0v5a7 7 0 0 1-7 7h-1a6 6 0 0 1-6-6v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 0 4H9"),
    SWORD("M14.5 17.5 3 6V3h3l11.5 11.5", "M13 19l6-6", "M16 16l4 4", "M19 21l2-2"),
    SWORDS("M14.5 17.5 3 6V3h3l11.5 11.5", "M13 19l6-6", "M16 16l4 4", "M19 21l2-2", "M14.5 6.5 18 3h3v3l-3.5 3.5", "M5 14l4 4", "M7 17l-3 3", "M3 19l2 2"),
    GUN("M3 8h16l2 2v3h-9l-1 5H6l1-5H5a2 2 0 0 1-2-2Z", "M18 8V6", "M12 13l-1-3"),
    STAFF("M5 21 15.5 10.5", circle(18f, 6f, 3f), "M18 1.5v1", "M22.5 6h-1"),
    AXE("m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z"),
    HAND("M8 13V5a1.5 1.5 0 0 1 3 0v6", "M11 11V4a1.5 1.5 0 0 1 3 0v7", "M14 11V5a1.5 1.5 0 0 1 3 0v8a7 7 0 0 1-7 7 6 6 0 0 1-5.2-3L3 14a1.5 1.5 0 0 1 2.6-1.5L8 15"),
    HAND_LEFT("M16 13V5a1.5 1.5 0 0 0-3 0v6", "M13 11V4a1.5 1.5 0 0 0-3 0v7", "M10 11V5a1.5 1.5 0 0 0-3 0v8a7 7 0 0 0 7 7 6 6 0 0 0 5.2-3L21 14a1.5 1.5 0 0 0-2.6-1.5L16 15"),
    HANDS("M3 20v-7a2 2 0 0 1 4 0v-3a2 2 0 0 1 4 0v10", "M13 20V10a2 2 0 0 1 4 0v3a2 2 0 0 1 4 0v7")
}

/** A circle as a path, so every icon is a plain list of paths. Top level: enum entries are built before a companion. */
private fun circle(cx: Float, cy: Float, r: Float): String =
    "M${cx - r} ${cy}a$r $r 0 1 0 ${2 * r} 0a$r $r 0 1 0 ${-2 * r} 0"

/**
 * Renders [icon] as inline SVG. The markup comes only from the constant paths above (never from user input),
 * so writing it with innerHTML is safe; a span wrapper keeps Compose in charge of the element itself.
 */
@Composable
fun Icon(icon: AppIcon, size: Int = 18, strokeWidth: Double = 2.0, label: String? = null) {
    val a11y = if (label == null) "aria-hidden=\"true\"" else "role=\"img\" aria-label=\"${label.replace("\"", "&quot;").replace("<", "&lt;")}\""
    val markup = buildString {
        append("<svg width=\"$size\" height=\"$size\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" ")
        append("stroke-width=\"$strokeWidth\" stroke-linecap=\"round\" stroke-linejoin=\"round\" focusable=\"false\" $a11y>")
        icon.paths.forEach { append("<path d=\"").append(it).append("\"></path>") }
        append("</svg>")
    }
    key(markup) {
        Span({
            style {
                property("display", "inline-flex")
                flexShrink(0)
                lineHeight("0")
            }
            ref { element ->
                element.innerHTML = markup
                onDispose { }
            }
        })
    }
}
